import { FunctionComponent } from 'react'

import { Path, Svg } from 'react-native-svg'
import { resize } from 'src/utils'

type Props = { size?: number }

export const AlertIcon62: FunctionComponent<Props> = ({ size = 24 }) => {
  const { height, width } = resize({ height: 24, size, width: 24 })

  return (
    <Svg {...{ viewBox: '0 0 24 24', width, height }}>
      <Path
        fill="#404040"
        d="M8.343.287A2.576 2.576 0 0 1 10.69.28l7.998 3.26a.475.475 0 0 1 .121.07l.018.014a.35.35 0 0 1 .048.046l.01.015a.472.472 0 0 1 .114.317l-.006-.077.005.044v.033l.002 4.084A1.5 1.5 0 0 1 20 9.5v2.998a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5V9.5a1.5 1.5 0 0 1 1-1.414V4.811l-2.007 1.012V13.5c0 .246-.176.45-.41.492l-.09.008H3.5a.5.5 0 0 1-.5-.5V5.811L.276 4.448a.501.501 0 0 1-.05-.867l.086-.044 8.03-3.25ZM4 6.311v6.69h10.993V6.325l-4.261 2.15a2.6 2.6 0 0 1-2.228.085l-.177-.083L4 6.311ZM18.5 9a.5.5 0 0 0-.5.5v2.498h1V9.5c0-.277-.223-.5-.5-.5Zm-8.228-7.813a1.604 1.604 0 0 0-1.491 0l-.042.02-7.026 2.843L8.78 7.587a1.608 1.608 0 0 0 1.496-.002l4.912-2.478a.5.5 0 0 1 .166-.084l1.939-.974-7.022-2.863Z"
      />
    </Svg>
  )
}
